module.exports = __webpack_public_path__ + "static/img/3-bg.e994bde.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/3-bg.png
// module id = jdkr
// module chunks = 0